import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { configQuery, interpolate, RoutablePage, FeatureEnabledV2, MagicConfigMixin, BalanceMixin } from '@gig/magic-common';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { BALANCE_UPDATED, GAMES_CURRENT_GAME_UPDATED, LOCKED_AMOUNT_UPDATED, US_DOLLARS_BALANCE_UPDATED, IS_REDEEM_FLOW_UPDATED, IS_MOBILE_APP_QUERY, BALANCE_CURRENCY_QUERY, BALANCE_CURRENCY_CHANGE, MOBILE_APP_BALANCE_ACTIVE_CURRENCY_UPDATED, BALANCE_FIAT_CURRENCY_QUERY, BALANCE_QUERY, Feature } from '@gig/magic-messages';

var SweepstakesBalance = /** @class */ (function (_super) {
    __extends(SweepstakesBalance, _super);
    function SweepstakesBalance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Currency = Currency;
        _this.isTopNavEnabled = true;
        _this.hasAnimations = false;
        _this.hideBalanceOnGameplay = false;
        _this.animateCoinShopButton = false;
        _this.goldBalance = null;
        _this.sweepBalance = null;
        _this.activeCurrency = Currency.GLD;
        _this.isTooltipOpen = false;
        _this.isMobile = false;
        _this.isDesktop = false;
        _this.isMobileApp = false;
        _this.isLandscape = false;
        // we need to add additional top offset for tooltip when we click on Gold Coin to see additional info
        _this.goldTooltipOffset = false;
        _this.hasUSD = false;
        _this.lockedUSD = null;
        _this.hasCancelRedeemFailed = false;
        _this.hasRedeemFlowStarted = false;
        _this.delayTimeout = null;
        _this.balanceSubscription = null;
        _this.gameSubscription = null;
        _this.gameData = null;
        _this.videoTimeInterval = null;
        _this.videoTimeIntervalTime = 5000; // 3000ms + 2000ms animation time
        return _this;
    }
    SweepstakesBalance.prototype.created = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var _c, _d, _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _c = this;
                        return [4 /*yield*/, configQuery('showBalanceCurrency')];
                    case 1:
                        _c.showBalanceCurrency =
                            (_a = (_f.sent())) !== null && _a !== void 0 ? _a : true;
                        _d = this;
                        return [4 /*yield*/, window.queryBus.query(BALANCE_CURRENCY_QUERY)];
                    case 2:
                        _d.activeCurrency = (_f.sent());
                        _e = this;
                        return [4 /*yield*/, window.queryBus.query(IS_MOBILE_APP_QUERY)];
                    case 3:
                        _e.isMobileApp =
                            (_b = (_f.sent())) !== null && _b !== void 0 ? _b : false;
                        return [4 /*yield*/, this.refreshBalance()];
                    case 4:
                        _f.sent();
                        this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, function () {
                            _this.delayTimeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.refreshBalance()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, _this.delay);
                        });
                        this.gameSubscription = window.eventBus.subscribe(GAMES_CURRENT_GAME_UPDATED, function (e) {
                            var _a;
                            _this.gameData = (_a = e.payload) !== null && _a !== void 0 ? _a : null;
                        }, { replay: true });
                        this.cancelRedeemFailSubscription = window.eventBus.subscribe(LOCKED_AMOUNT_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                this.hasCancelRedeemFailed = (_a = event === null || event === void 0 ? void 0 : event.payload) !== null && _a !== void 0 ? _a : false;
                                return [2 /*return*/];
                            });
                        }); }, { replay: true });
                        this.usDollarsBalanceSubscription = window.eventBus.subscribe(US_DOLLARS_BALANCE_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.hasUSD = event.payload;
                                return [2 /*return*/];
                            });
                        }); }, { replay: true });
                        this.hasRedeemFlowStartedSubscription =
                            window.eventBus.subscribe(IS_REDEEM_FLOW_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    this.hasRedeemFlowStarted = (_a = event === null || event === void 0 ? void 0 : event.payload) !== null && _a !== void 0 ? _a : false;
                                    return [2 /*return*/];
                                });
                            }); }, { replay: true });
                        this.startVideoInterval();
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBalance.prototype.destroyed = function () {
        var _a, _b, _c, _d, _e;
        (_a = this.balanceSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.gameSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        this.clearVideoTimeout();
        (_c = this.usDollarsBalanceSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        (_d = this.cancelRedeemFailSubscription) === null || _d === void 0 ? void 0 : _d.unsubscribe();
        (_e = this.hasRedeemFlowStartedSubscription) === null || _e === void 0 ? void 0 : _e.unsubscribe();
    };
    SweepstakesBalance.prototype.showText = function (currency) {
        if (this.isDesktop || this.fullscreen) {
            return true;
        }
        else if (this.isLandscape) {
            return !this.gameplay;
        }
        else {
            return this.isMobile ? currency === this.activeCurrency : true;
        }
    };
    Object.defineProperty(SweepstakesBalance.prototype, "tooltipPosition", {
        get: function () {
            this.goldTooltipOffset = false;
            if (this.isDesktop && !this.gameplay) {
                return 'right';
            }
            else if (this.isDesktop && this.gameplay) {
                return 'bottom';
            }
            else if (this.isLandscape && this.gameplay) {
                if (this.fullscreen) {
                    return 'bottom';
                }
                this.goldTooltipOffset = true;
                return 'right';
            }
            else {
                return 'bottom';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesBalance.prototype, "isGameRunning", {
        get: function () {
            return this.gameData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesBalance.prototype, "showLockedAmountNotification", {
        get: function () {
            var _a, _b;
            var lockedBalance = (_b = (_a = this.lockedUSD) === null || _a === void 0 ? void 0 : _a.balance) !== null && _b !== void 0 ? _b : 0;
            var hasLockedBalance = lockedBalance > 0;
            var redeemNotStarted = !this.hasRedeemFlowStarted;
            return (redeemNotStarted &&
                ((hasLockedBalance && this.hasCancelRedeemFailed) ||
                    (this.hasUSD && hasLockedBalance)));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesBalance.prototype, "formattedGoldBalance", {
        get: function () {
            if (this.hideBalanceOnGameplay &&
                this.activeCurrency === Currency.GLD &&
                this.isGameRunning) {
                return this.$t('sweepstakes.balance.playing');
            }
            var translationKey = this.showBalanceCurrency
                ? 'sweepstakes.goldcoins-short'
                : 'sweepstakes.balance-amount-only';
            return interpolate(this.$t(translationKey), {
                amount: this.formatIfOverLimit(this.goldBalance.balance),
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakesBalance.prototype, "formattedSweepBalance", {
        get: function () {
            if (this.hideBalanceOnGameplay &&
                this.activeCurrency === Currency.SWP &&
                this.isGameRunning) {
                return this.$t('sweepstakes.balance.playing');
            }
            var translationKey = this.showBalanceCurrency
                ? 'sweepstakes.sweepcoins-short'
                : 'sweepstakes.balance-amount-only';
            return interpolate(this.$t(translationKey), {
                amount: this.formatIfOverLimit(this.sweepBalance.balance),
            });
        },
        enumerable: false,
        configurable: true
    });
    SweepstakesBalance.prototype.setActiveCurrency = function (currency) {
        if (this.activeCurrency !== currency) {
            this.activeCurrency = currency;
            this.isTooltipOpen = false;
            window.commandBus.publish(BALANCE_CURRENCY_CHANGE, this.activeCurrency);
            if (this.isMobileApp) {
                window.eventBus.publish(MOBILE_APP_BALANCE_ACTIVE_CURRENCY_UPDATED, this.activeCurrency);
            }
        }
        else {
            this.isTooltipOpen = !this.isTooltipOpen;
        }
    };
    SweepstakesBalance.prototype.onFullscreenChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isTooltipOpen = false;
                return [2 /*return*/];
            });
        });
    };
    SweepstakesBalance.prototype.delayChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.delay === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.refreshBalance()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.clearTimer();
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBalance.prototype.routeToShop = function () {
        this.routeTo({ route: RoutablePage.SWEEPSTAKES_SHOP });
    };
    SweepstakesBalance.prototype.clearTimer = function () {
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
            this.delayTimeout = null;
        }
    };
    SweepstakesBalance.prototype.startVideoInterval = function () {
        var _this = this;
        this.clearVideoTimeout();
        this.videoTimeInterval = setInterval(function () {
            _this.playVideo();
        }, this.videoTimeIntervalTime);
    };
    SweepstakesBalance.prototype.clearVideoTimeout = function () {
        if (this.videoTimeInterval) {
            clearInterval(this.videoTimeInterval);
            this.videoTimeInterval = null;
        }
    };
    SweepstakesBalance.prototype.playVideo = function () {
        var video = this.$refs.buyButtonVideo;
        if (video) {
            video.currentTime = 0;
            video.play().catch(function () {
                // Handle any play errors silently
            });
        }
    };
    SweepstakesBalance.prototype.loopVideo = function () {
        var video = this.$refs.buyButtonVideo;
        if (video) {
            this.clearVideoTimeout();
            video.loop = true;
            video.play().catch(function () {
                // Handle any play errors silently
            });
        }
    };
    SweepstakesBalance.prototype.refreshBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userCurrency, _a, goldBalance, sweepBalance, usdBalance;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                    case 1:
                        userCurrency = _b.sent();
                        return [4 /*yield*/, Promise.all([
                                this.queryBalance(Currency.GLD),
                                this.queryBalance(Currency.SWP),
                                this.queryBalance(userCurrency),
                            ])];
                    case 2:
                        _a = _b.sent(), goldBalance = _a[0], sweepBalance = _a[1], usdBalance = _a[2];
                        this.goldBalance = goldBalance;
                        this.sweepBalance = sweepBalance;
                        this.lockedUSD = usdBalance;
                        return [2 /*return*/];
                }
            });
        });
    };
    SweepstakesBalance.prototype.queryBalance = function (currency) {
        return window.queryBus.query(BALANCE_QUERY, currency);
    };
    SweepstakesBalance.prototype.resetVideo = function () {
        var video = this.$refs.buyButtonVideo;
        if (video) {
            video.loop = false;
        }
        this.startVideoInterval();
    };
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], SweepstakesBalance.prototype, "delay", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SweepstakesBalance.prototype, "gameplay", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SweepstakesBalance.prototype, "fullscreen", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TOP_NAVIGATION,
        }),
        __metadata("design:type", Object)
    ], SweepstakesBalance.prototype, "isTopNavEnabled", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.SWEEPCOINS_ANIMATION_TRANSITION,
        }),
        __metadata("design:type", Object)
    ], SweepstakesBalance.prototype, "hasAnimations", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.HIDE_SWEEPX_BALANCE_ON_GAMEPLAY,
        }),
        __metadata("design:type", Object)
    ], SweepstakesBalance.prototype, "hideBalanceOnGameplay", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.ANIMATE_COIN_SHOP_BUTTON,
        }),
        __metadata("design:type", Object)
    ], SweepstakesBalance.prototype, "animateCoinShopButton", void 0);
    __decorate([
        Watch('fullscreen'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SweepstakesBalance.prototype, "onFullscreenChange", null);
    __decorate([
        Watch('delay'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SweepstakesBalance.prototype, "delayChanged", null);
    SweepstakesBalance = __decorate([
        Component({
            name: 'sweepstakes-balance',
        })
    ], SweepstakesBalance);
    return SweepstakesBalance;
}(Mixins(MagicConfigMixin, BalanceMixin)));

export default SweepstakesBalance;
